import NAME from "./constants";

export const snackbarIsOpen = store => store[NAME].open;
export const getSnackbarMessage = store => store[NAME].msg || "";
export const getDuration = store => store[NAME].duration || null;
export const getSeverity = store => store[NAME].severity || "info";
export const getPath = store => store[NAME].path || null;